import script from "./NewsPageSearchSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageSearchSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageSearchSwitcher.vue?vue&type=style&index=0&id=06a32032&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06a32032"]])

export default __exports__